/* Accessibility (WCAG 2.2.2 Pause, Stop, Hide) — Biophase Labs
   Adds a keyboard-accessible pause/play button to every auto-moving region
   (marquees, scrolling text, autoplaying background videos) and starts them
   paused for visitors who have "reduce motion" turned on. */
(function () {
  var PAUSE_ICON = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><rect x="3" y="2" width="3.5" height="12"/><rect x="9.5" y="2" width="3.5" height="12"/></svg>';
  var PLAY_ICON = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M4 2l10 6-10 6z"/></svg>';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var REGION_SELECTORS = [
    '.wt-announcement__container--marquee',
    'scrolling-text-banner',
    '.wt-brands__container--marquee',
    '.wt-testimonials-marquee__container'
  ];

  function setButton(btn, paused, label) {
    btn.innerHTML = paused ? PLAY_ICON : PAUSE_ICON;
    btn.setAttribute('aria-label', (paused ? 'Play ' : 'Pause ') + label);
    btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
  }

  function addToggle(host, label, onToggle, startPaused) {
    if (host.querySelector(':scope > .a11y-motion-toggle')) return;
    host.classList.add('a11y-motion-host');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'a11y-motion-toggle';
    var paused = !!startPaused;
    setButton(btn, paused, label);
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      paused = !paused;
      onToggle(paused);
      setButton(btn, paused, label);
    });
    host.appendChild(btn);
    if (paused) onToggle(true);
  }

  function initRegions(root) {
    REGION_SELECTORS.forEach(function (sel) {
      (root || document).querySelectorAll(sel).forEach(function (el) {
        addToggle(el, 'scrolling content', function (paused) {
          el.classList.toggle('a11y-motion-paused', paused);
        }, reduceMotion);
      });
    });

    (root || document).querySelectorAll('video[autoplay]').forEach(function (video) {
      if (video.controls || video.closest('video-controls') || video.closest('.a11y-motion-host')) return;
      var host = video.parentElement;
      if (!host) return;
      addToggle(host, 'background video', function (paused) {
        if (paused) { video.pause(); } else { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
      }, reduceMotion);
    });
  }

  /* Scrolling text banners clone their text many times for the loop and hide the
     original. Screen readers would hear every clone, and none of the original.
     Keep ONE readable copy (visually hidden) and hide the moving clones from AT. */
  function fixScrollingBanner(banner) {
    var apply = function () {
      banner.querySelectorAll('.scrolling-outer').forEach(function (o) {
        if (o.getAttribute('aria-hidden') !== 'true') o.setAttribute('aria-hidden', 'true');
      });
      if (!banner.querySelector('.scrolling-outer')) return;
      banner.querySelectorAll('.hero__icon-with-text').forEach(function (orig) {
        if (orig.closest('.scrolling-outer')) return;
        if (orig.inert) orig.inert = false;
        if (orig.style.display === 'none') orig.style.display = '';
        orig.classList.add('a11y-sr-only');
      });
    };
    apply();
    if (!banner.__a11yObserved && window.MutationObserver) {
      banner.__a11yObserved = true;
      new MutationObserver(apply).observe(banner, { childList: true, subtree: true });
    }
  }

  function initAll(root) {
    initRegions(root);
    (root || document).querySelectorAll('scrolling-text-banner').forEach(fixScrollingBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  // Re-run when the theme editor reloads a section
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
